// Compact, locale-aware number text for tight tiles: 1387140 -> "1.39M" (en),
// "1,39 M" (es). Falls back to the plain value when Intl rejects the locale.
export const formatCompactCount = (value, locale) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  const opts = { notation: 'compact', maximumFractionDigits: 2 };
  try {
    return new Intl.NumberFormat(locale || 'en', opts).format(n);
  } catch {
    return new Intl.NumberFormat('en', opts).format(n);
  }
};
